import { render } from "./return-item.vue?vue&type=template&id=57e26530&scoped=true&ts=true"
import script from "./return-item.vue?vue&type=script&lang=ts"
export * from "./return-item.vue?vue&type=script&lang=ts"

import "./return-item.vue?vue&type=style&index=0&id=57e26530&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e26530"]])

export default __exports__